import ProductContext from '../../../../_helper/Ecommerce/Product';
import { Price, MoveToCarts } from '../../../../Constant';
import CartContext from '../../../../_helper/Ecommerce/Cart';
import { Btn, H6, Image } from '../../../../AbstractElements';
import { useNavigate } from 'react-router';
import { Col, Media, Label,Row, Modal, ModalHeader, ModalBody, Input, FormGroup, Form } from 'reactstrap';
import React, { Fragment, useContext,useState } from 'react';
import CustomizerContext from '../../../../_helper/Customizer';
import {Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import ContactAppContext from '../../../../_helper/Contact';
import defaultuser from '../../../../assets/images/user/user.png';

const WishListData = () => {
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const { productItem, symbol } = useContext(ProductContext); 
  const [addurl, setAddurl] = useState(defaultuser);
  const { addToCart } = useContext(CartContext);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const { createUser } = useContext(ContactAppContext);

  const tekoModal = () => {alert('Hi');
      setModal(!modal);
    };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(); // initialise the hook

  const AddContact = (data) => {
    if (data !== '') {
      createUser(data, addurl);
      setModal(false);
    } else {
      errors.showMessages();
    }
  };

  const MoveToCart = (product, qty) => {
    addToCart(product, qty);
    /*history(`${process.env.PUBLIC_URL}/app/ecommerce/cart/${layoutURL}`);*/
  };
  var images = require.context('../../../../assets/images', true);
  const dynamicImage = (image) => {
    return images(`./${image}`);
  };
  return (
    <Fragment>
      {productItem.map((item) => {
        return (
          <Col key={item.id} xl='4' md='6'>
            <div className='prooduct-details-box'>
              <Media>
               
                <div className='media-body ms-3'>
                  <div className='product-name'>
                    <H6>
					
                      
                      <Link to={`${process.env.PUBLIC_URL}`+item.linki}>{item.name}</Link>
                     
					  					  
					  
                    </H6>
                  </div>
                 
                 <div>
                  <div className='avaiabilty'>
                    <div className='text-success'>{item.stock}</div>
                  </div>
				  
                  
                   <Link to={`${process.env.PUBLIC_URL}`+item.linki}>
					         <Btn
                    attrBtn={{
                      color: 'primary',
                      size: 'xs',
                      
                    }}>
                    {"View More"}
                  </Btn></Link></div>
					 
				  
				  
                </div>
              </Media>
            </div>
          </Col>
        );
      })}
    </Fragment>
  );
};
export default WishListData;
